export const appendIfPresent = (params, key, value) => {
  if (typeof value === 'undefined' || value === null || value === '')
    return
  params.set(key, value)
}

export const withQuery = (url, params) => {
  const search = new URLSearchParams()
  params.forEach(([key, value]) => appendIfPresent(search, key, value))
  const qs = search.toString()
  return qs ? `${url}?${qs}` : url
}
